/**
 * Site Types Constants (SINGLE SOURCE OF TRUTH)
 * 
 * Defines the different site/vertical types for analytics tracking.
 * Used to track which landing page or mini-site a visitor came from.
 * 
 * This is the canonical source - all apps should import from @wfvr/types.
 */

/**
 * Site type identifiers used for analytics tracking
 */
export const SITE_TYPES = {
  /** Main selna.ai landing page */
  MAIN_SITE: 'main_landing_page',
  
  /** Hotel vertical landing page (selna.ai/hotel) */
  HOTEL_PAGE: 'hotel_landing_page',
  
  /** Sales/B2B vertical landing page (selna.ai/sales) */
  SALES_PAGE: 'sales_landing_page',
  
  /** Game landing page (game.selna.ai) */
  GAME_PAGE: 'game_landing_page',
  
  // ──────────────────────────────────────────────────────────────────────────
  // Add future verticals here:
  // RESTAURANT_PAGE: 'restaurant_landing_page',
  // HEALTHCARE_PAGE: 'healthcare_landing_page',
  // ──────────────────────────────────────────────────────────────────────────
} as const;

/**
 * Type representing valid site type values
 */
export type SiteType = typeof SITE_TYPES[keyof typeof SITE_TYPES];

/**
 * Display labels for each site type (used in admin dashboard)
 */
export const SITE_TYPE_LABELS: Record<SiteType, { emoji: string; label: string }> = {
  [SITE_TYPES.MAIN_SITE]: { emoji: '🌐', label: 'Main site' },
  [SITE_TYPES.HOTEL_PAGE]: { emoji: '🏨', label: 'Hotel page' },
  [SITE_TYPES.SALES_PAGE]: { emoji: '💼', label: 'Sales page' },
  [SITE_TYPES.GAME_PAGE]: { emoji: '🎮', label: 'Game page' },
  // Add labels for new verticals here
};

/**
 * All valid site type values (for validation)
 */
export const VALID_SITE_TYPES: SiteType[] = Object.values(SITE_TYPES);

/**
 * Default site type when none is specified
 */
export const DEFAULT_SITE_TYPE: SiteType = SITE_TYPES.MAIN_SITE;
